import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../data/mockData";
import { Phone, ArrowRight, Calendar } from "lucide-react";

const ContactCTA = () => {
  return (
    <section className="py-20 lg:py-28 bg-[#3A7D44] relative overflow-hidden">
      {/* Subtle pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Ready to Find the Right Plan?
        </h2>
        <p className="text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Let's have a conversation about your needs. No pressure, no jargon
          — just honest guidance to help you make a confident decision.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <a
            href={siteConfig.calendlyUrl}
            
            
            className="inline-flex items-center gap-2 px-8 py-4 text-base font-semibold text-[#3A7D44] bg-white rounded-lg hover:bg-gray-50 transition-colors duration-200 shadow-lg"
          >
            <Calendar size={18} />
            Book a Free Call
          </a>
          <a
            href={`tel:${siteConfig.phone}`}
            className="inline-flex items-center gap-2 px-8 py-4 text-base font-semibold text-white border-2 border-white/40 rounded-lg hover:bg-white/10 transition-colors duration-200"
          >
            <Phone size={18} />
            Call {siteConfig.phoneFormatted}
          </a>
        </div>

        <p className="mt-8 text-sm text-white/60">
          Free consultations • No obligation • Available Monday–Friday, 9AM–5PM
        </p>
      </div>
    </section>
  );
};

export default ContactCTA;
